import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from "react";
type Props = {
  widget: Widget;
  argument?: string | undefined;
  id?: string;
};
type Widget = "404" | "upsell" | "recentlyViewed" | "crosssell" | "related" | "personal" | "favorites";
const widgets: Record<Widget, number> = {
  "404": 65034,
  // https://t2.mindbox.ru/personalization/reco-widget/65034

  upsell: 65038,
  // https://t2.mindbox.ru/personalization/reco-widget/65038

  recentlyViewed: 65039,
  // https://t2.mindbox.ru/personalization/reco-widget/65039

  crosssell: 65040,
  // https://t2.mindbox.ru/personalization/reco-widget/65040

  related: 75771,
  // https://t2.mindbox.ru/personalization/reco-widget/75771

  personal: 65037,
  // https://t2.mindbox.ru/personalization/reco-widget/65037

  favorites: 65041
  // https://t2.mindbox.ru/personalization/reco-widget/65041
};

/* [m.kudryashov 21.11.2023 - 13:44]: нельзя удалять корневой div потому что mindbox может удалить внутренний div и 
без внешнего React сломается см. https://pm.aristos.pw/issue/BRLY-2064 */
const MindboxWidget: FunctionComponent<Props> = t0 => {
  const $ = _c(4);
  const {
    widget,
    argument,
    id
  } = t0;
  const t1 = widgets[widget];
  let t2;
  if ($[0] !== argument || $[1] !== id || $[2] !== t1) {
    t2 = <div><div data-popmechanic-embed={t1} data-popmechanic-argument={argument} id={id} /></div>;
    $[0] = argument;
    $[1] = id;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default MindboxWidget;